export type InsuranceAgeError =
  | 'required'
  | 'adultMin'
  | 'adultMax'
  | 'infantMin'
  | 'infantMax'

export const MAX_INSURANCE_TRAVELERS = 8

export const MIN_INSURANCE_AGE = 1
export const MAX_ADULT_AGE = 85
export const MAX_INFANT_AGE = 11

export const resizeInsuranceAges = (ages: string[], count: number): string[] =>
  Array.from({ length: count }, (_, index) => ages[index] ?? '')

export const getInsuranceCountLimit = (otherCount: number): number =>
  Math.max(0, MAX_INSURANCE_TRAVELERS - otherCount)

export const getInsuranceAgeError = (
  age: string,
  kind: 'adult' | 'infant',
): InsuranceAgeError | null => {
  const normalizedAge = age.trim()

  if (!normalizedAge) return 'required'

  const minError = kind === 'adult' ? 'adultMin' : 'infantMin'
  const maxError = kind === 'adult' ? 'adultMax' : 'infantMax'
  const maxAge = kind === 'adult' ? MAX_ADULT_AGE : MAX_INFANT_AGE

  if (
    !/^\d+$/.test(normalizedAge) ||
    Number(normalizedAge) < MIN_INSURANCE_AGE
  ) {
    return minError
  }

  if (Number(normalizedAge) > maxAge) return maxError

  return null
}
